import { createAction } from 'redux-actions'

export const addLayersAction = createAction('ADD_LAYERS')
export const deleteLayerAction = createAction('DELETE_LAYER')
export const editLayerAction = createAction('EDIT_LAYER')
export const sortLayersAction = createAction('SORT_LAYERS')
export const setLayersKeysAction = createAction('SET_LAYERS_KEYS')
export const setLayersDataAction = createAction('SET_LAYERS_DATA')
export const setLayersLegendsAction = createAction('SET_LAYERS_LEGENDS')

export const setLayersData = layers =>
  dispatch => {
    dispatch(setLayersDataAction(layers))
  }

export const setLayersLegends = legends =>
  dispatch => {
    dispatch(setLayersLegendsAction(legends))
  }

export const addLayers = layers =>
  dispatch => {
    dispatch(addLayersAction({ layers }))
  }

export const deleteLayer = layer =>
  dispatch => {
    dispatch(deleteLayerAction({ layer }))
  }

export const editLayer = (layer, config, value) =>
  dispatch => {
    dispatch(editLayerAction({ layer, config, value }))
  }

export const sortLayers = layers =>
  dispatch => {
    dispatch(sortLayersAction({ layers }))
  }

export const setLayersKeys = keys =>
  dispatch => {
    dispatch(setLayersKeysAction({ keys }))
  }



// WEBPACK FOOTER //
// ./src/actions/layers.js